import { Table, TableBody, TableCell, TableHead, TablePagination, TableRow } from "@mui/material";
import React from "react";

import MDTypography from "@/components/atoms/MDTypography";
import {
  HeaderTableCell,
  TableContainer,
  TableHeaderRow,
} from "@/components/molecules/Table/styled";
import { DEFAULT_ROWS_PER_PAGE_OPTIONS } from "@/constants/pagination";
import IContact from "@/interfaces/contact.interface";
import { CampaignFormMessages } from "@/messages/campaigns/campaign-form.messages";
import { Pagination } from "@/types/page.types";
import { PaginatedResponse } from "@/types/requests.types";

import ContactRow from "./row";
import { CONTACTS_TABLE_COLUMNS } from "../../constants";

type Props = {
  contacts?: IContact[];
  messages: CampaignFormMessages;
  data: PaginatedResponse<IContact> | null | undefined;
  pagination: Pagination;
  hasSearched?: boolean;
};

function ContactsTable({
  contacts,
  messages,
  data,
  pagination,
  hasSearched = false,
}: Props) {
  const emptyMessage = hasSearched
    ? messages.noActiveContactsFoundMessage
    : messages.noContactMessage;
  return (
    <>
      <TableContainer sx={{ boxShadow: "none" }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableHeaderRow>
              {CONTACTS_TABLE_COLUMNS(messages).map((label, index) => (
                <HeaderTableCell key={`${index} - ${label}`}>{label}</HeaderTableCell>
              ))}
            </TableHeaderRow>
          </TableHead>
          <TableBody>
            {!contacts || contacts.length <= 0 ? (
              <TableRow>
                <TableCell colSpan={CONTACTS_TABLE_COLUMNS(messages).length} align="center">
                  <MDTypography variant="h6" color="text" fontWeight={"regular"}>
                    {emptyMessage}
                  </MDTypography>
                </TableCell>
              </TableRow>
            ) : (
              contacts &&
              contacts.map((contact, index) => (
                <ContactRow key={index} contact={contact} index={index} messages={messages} />
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        labelRowsPerPage={messages.rowsPerPage}
        rowsPerPageOptions={DEFAULT_ROWS_PER_PAGE_OPTIONS}
        component="div"
        count={data ? data.totalCount : 0}
        onRowsPerPageChange={(e) => pagination.extend(Number(e.target.value))}
        rowsPerPage={pagination.pageSize}
        page={pagination.pageNumber - 1}
        onPageChange={(_, pageNumber) => pagination.changePage(pageNumber)}
      />
    </>
  );
}

export default ContactsTable;
